import { jsonCopy } from '../../../utility/genericUtility';
import { datiGeneraliBenefMorteInizializzato, datiResidenzaInizializzato, 
	     datiAntiriciclaggioInizializzato, datiRelazContrInizializzato, 
	     datiCopiaDaAltraFiguraInizializzato } 
	from '../componentiBase/sezioniAnagrafica';

export const datiGeneraliBenefMorte = jsonCopy(datiGeneraliBenefMorteInizializzato);
export const datiResidenza = jsonCopy(datiResidenzaInizializzato);
export const datiAntiriciclaggio = jsonCopy(datiAntiriciclaggioInizializzato);
export const datiRelazContr = jsonCopy(datiRelazContrInizializzato);
export const datiCopiaDaAltraFigura = jsonCopy(datiCopiaDaAltraFiguraInizializzato);
  
